import { Modal } from "@appkit4/react-components";
import { useSelector } from "react-redux";

const SupportPanel = ({ visible, setVisible }) => {
  const isClientFacing = useSelector((state) => state.usageInfo.isClientFacing);

  const supportResources = [
    {
      name: "CIR Analyser User Guide",
      href: "https://pwcgbr.sharepoint.com/:w:/r/sites/GB-SD-0ANE03Vu5Ex0LUk9PVA/Shared%20Documents/Technical%20resources%20and%20papers_/CIR/Corporate%20Interest%20Restriction%20Analyser%20-%20User%20guide%20.docx?d=w67b072b8d49e47b1872f7d7a6eaac629&csf=1&web=1&e=r8QF1E",
      description:
        "The User Guide is structured to walk you through every aspect of the CIR Analyser, from initial setup and data input to generating outputs. Should you encounter any challenges or have questions as you use the CIR Analyser, this guide should be your first point of reference.",
      show: !isClientFacing,
    },
    {
      name: "CIR Analyser Technical Guide",
      href: "https://pwcgbr.sharepoint.com/:w:/r/sites/GB-SD-0ANE03Vu5Ex0LUk9PVA/Shared%20Documents/Technical%20resources%20and%20papers_/CIR/Corporate%20Interest%20Restriction%20Analyser%20-%20Technical%20guide%20.docx?d=w2647daaaa71d46369b759c1fbe105a0e&csf=1&web=1&e=1lJ42W",
      description:
        "The Technical Guide is an important resource for understanding how the technicalities of the CIR legislation are applied within the framework of the CIR Analyser. It provides a high-level overview of certain parts of the legislation to support you in inputting values and understanding certain data validations.",
      show: !isClientFacing,
    },
    {
      name: "CIR Technical Paper",
      href: "https://pwcgbr.sharepoint.com/:w:/r/sites/GB-SD-0AH8Zv3E5Dv1YUk9PVA/_layouts/15/Doc.aspx?sourcedoc=%7b1601B50D-C8E9-413E-92A9-7F5427460594%7d&file=MIGRATED%20TO%20SP%20-%20DO%20NOT%20EDIT%20-%20Corporate%20interest%20deductibility%20rules%20%28post%201%20April%202017%29%20-%20Technical%20Paper.docx&action=default&mobileredirect=true&DefaultItemOpen=1",
      description:
        "The CIR Technical Paper is a general guide that provides details on the application of the CIR legislation.",
      show: !isClientFacing,
    },
    {
      name: "Link to HMRC CIR Guidance",
      href: "https://www.gov.uk/hmrc-internal-manuals/corporate-finance-manual/cfm95000",
      description:
        "HMRC's CIR Guidance is included in CFM95000 onwards of the Corporate Finance Manual and provides HMRC's interpretation of the legislation.",
      show: true,
    },
    {
      name: "List of CIR Champions",
      href: "https://pwcgbr.sharepoint.com/:x:/r/sites/GB-SD-0ANE03Vu5Ex0LUk9PVA/Shared%20Documents/Technical%20resources%20and%20papers_/CIR/CIR%20Champions.xlsx?d=w42182a3f52524e548538f1e28f0e000a&csf=1&web=1&e=aKbEog",
      description:
        "A group of CIR champions, who have experience of using the CIR Analyser can be found by clicking on the link above. Your local CIR Champion should be able to assist with technical CIR support and using the CIR Analyser.",
      show: !isClientFacing,
    },
    {
      name: "Email uk_cir_app_support@pwc.com",
      href: "mailto:uk_cir_app_support@pwc.com?subject=CIR App Support",
      description:
        "If the above resources do not provide an answer to your question, or you have an issue in using the CIR Analyser for your group, you can contact us at uk_cir_app_support@pwc.com by clicking on the link above. Please ensure that you have checked the above resources before reaching out.",
      show: true,
    },
  ];

  return (
    <Modal
      initialFocus={false}
      visible={visible}
      title={"Support"}
      ariaLabel={"Support"}
      onCancel={() => setVisible(false)}
      maskCloseable={true}
      modalStyle={{ width: "50rem" }}
      footerStyle={{
        paddingTop: "8px",
        marginTop: "-8px",
        minHeight: "100px",
      }}
      header={""}
      icons={""}
    >
      <p>
        We have developed a number of resources to assist you in using the CIR
        Analyser
      </p>

      <br />

      {supportResources.map(
        (resource) =>
          resource.show && (
            <>
              <div key={resource.name}>
                <h4>
                  <a href={resource.href} target="_blank" rel="noreferrer">
                    {resource.name}
                    <span
                      className="Appkit4-icon icon-link-outline ap-font-24 ap-container-24"
                      aria-hidden="true"
                      style={{ marginLeft: "2px" }}
                    ></span>
                  </a>
                </h4>
                {resource.description}
              </div>

              <br />
            </>
          ),
      )}
    </Modal>
  );
};

export default SupportPanel;
